import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

import { Spinner } from '@zippeditoolsjs/ui-web';

export default function TotpQrPanel({ uri, size = 150, className = '' }) {
  const { t } = useTranslation();

  return (
    <div className={`flex justify-center ${className}`.trim()}>
      {/* Spinner is aria-hidden, so the panel itself carries the busy state: the
          live region must outlive the swap for the change to be announced. */}
      <div
        role="status"
        aria-busy={!uri}
        className="flex items-center justify-center rounded-lg border border-solid border-muted bg-surface-hover p-4 shadow-[0_2px_8px_rgba(26,36,45,.05)] dark:border-border dark:bg-surface">
        {uri ? (
          // Literal hex: fgColor lands on an SVG fill attribute, which does not
          // resolve CSS variables. Mirrors --zippedi-text-primary.
          <QRCodeSVG value={uri} size={size} fgColor="#1a242d" />
        ) : (
          <>
            <Spinner size="lg" tone="accent" className="m-[55px]" />
            <span className="sr-only">{t('heimdal_app.TOTP.qr_loading')}</span>
          </>
        )}
      </div>
    </div>
  );
}

TotpQrPanel.propTypes = {
  uri: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};
